@let subsection = subSectionService.subsection();
@let visible = subSectionService.subsectionVisible();
@if (subsection && visible) {
  <div
    [class]="'h-full'"
    [style.background-color]="'white'"
    style="scroll-margin-top: 108px"
    #ref
  >
    <div
      [pTooltip]="subsection.customization.description"
      class="flex flex-row items-center justify-between gap-2 px-5 pt-3"
    >
      <div class="flex flex-col gap-1">
        <div class="text-lg font-bold">
          {{ subsection.customization.title }}
        </div>
        <div class="text-sm">{{ subsection.customization.subTitle }}</div>
      </div>
    </div>

    <div>
      <div class="list flex flex-col gap-4 px-5 py-3">
        @for (widget of subsection.children; track $index; let i = $index) {
          <lib-base-element-compiling [widgetId]="widget" />
        }
      </div>
    </div>
  </div>
}
